import { render, staticRenderFns } from "./abstract-passenger-modal.vue?vue&type=template&id=12a07314"
import script from "./abstract-passenger-modal.vue?vue&type=script&lang=js"
export * from "./abstract-passenger-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports